import type { Booking, BookingStatus } from 'shared-types/booking';
import type { LightSpeedRequest } from 'shared-types/lightSpeedRequest';
import type { RoomSlots } from 'shared-types/roomSlots';

import client from './client';

export const getNextSessionsForRoom = async (roomId: number): Promise<[Booking]> => {
  return client.get(`/bam-api/next-sessions/${roomId}`);
};

export const searchDaily = async (search: string): Promise<[Booking]> => {
  return client.get(`/bam-api/search-daily/${search}`);
};

export const getRoomSlots = async (bamRoomId: number): Promise<RoomSlots[]> => {
  return client.get(`/bam-api/room-slots/${bamRoomId}`);
};

export const getBamRoomId = async (roomId: string): Promise<{ id: number }> => {
  return client.get(`/bam-api/bam-room/${roomId}`);
};

export const extendBooking = async (
  bookingId: number,
  minutes: number,
  price: number,
): Promise<Booking | null> => {
  return client.post('/bam-api/extend-booking', { minutes, price, bookingId });
};

export const updateBookingStatus = async (bookingId: number, status: BookingStatus) => {
  return client.post('/bam-api/update-booking-status', { bookingId, status });
};

export const sendOrderToLightSpeed = async (data: LightSpeedRequest) => {
  client.post('/bam-api/send-order-to-lightspeed', data);
};
